export const INIT_SETTINGS = 'INIT_SETTINGS';

export const USB_KEY_CHANGED = 'USB_KEY_CHANGED';

export default { INIT_SETTINGS, USB_KEY_CHANGED };
